import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, finalize, map, tap, throwError } from 'rxjs';
import { EmploymentType } from '../models/employment-type.model';
import { localizeData } from './_localizeData';
import { API_CONFIG } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class EmploymentTypeService {
  private isLoading: boolean = false;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  getEmploymentTypes(): Observable<EmploymentType[]> {
    const lang = this.translate.currentLang || this.translate.getDefaultLang();
    const url = `${API_CONFIG.endpoint}/employment-types?populate[localizations]=true`;
    this.isLoading = true;

    return this.http.get<{ data: EmploymentType[] }>(url).pipe(
      map((response) => response.data),
      tap((employmentTypes) => {
        localizeData(employmentTypes, lang);
      }),
      finalize(() => {
        this.isLoading = false;
      }),
      catchError((error) => {
        this.toastr.error(this.translate.instant('EMPLOYMENT_TYPES_LOADING_ERROR'));
        return throwError(
          () => new Error('Erreur lors du chargement des types de contrat')
        );
      })
    );
  }

  getLoadingStatus(): boolean {
    return this.isLoading;
  }
}
